import cookieHelper from '@/utils/cookieHelper'
import axiosHelper from '@/utils/axiosHelper'

export default {
  // 获取当前用户编号
  getUserCode: function () {
    const userInfoJson = cookieHelper.getCookie('userInfo')
    if (userInfoJson) {
      const userInfo = JSON.parse(decodeURI(userInfoJson))
      return userInfo.UserCode
    } else {
      return ''
    }
  },

  // 获取当前用户名称
  getUserName: function () {
    const userInfoJson = cookieHelper.getCookie('userInfo')
    if (userInfoJson) {
      const userInfo = JSON.parse(decodeURI(userInfoJson))
      return userInfo.UserName
    } else {
      return ''
    }
  },

  // 获取当前用户头像图片路径
  getUserHeadPortraitUrl: function () {
    const userInfoJson = cookieHelper.getCookie('userInfo')
    if (userInfoJson) {
      const userInfo = JSON.parse(decodeURI(userInfoJson))
      return userInfo.HeadPortraitUrl
    } else {
      return ''
    }
  },

  // 获取用户头像文件夹路径
  getHeadPortraitUrl: async function () {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/SYS.GetHeadPortraitUrl', {})
    if (rtnObj.error === '000000') {
      return rtnObj.path
    } else {
      return ''
    }
  }
}
